<template>
<div class="chapter">
<div class="inner_page">
<div id="Opening-Letter.html" xml:lang="en-US">
<div class="PL-Title-Page-Dividing-Line-1">
<p class="sub"><em class="italic"><a id="Anchor-1"></a>Laurel</em></p>
<p class="body-text-no-tab"><em class="italic">They took my baby from me when he was only ten hours old.</em></p>
<p class="body-text"><em class="italic">Jamie named him Andrew after his father, because it seemed fitting. We tried the name out once or twice to see how it felt in our mouths. Andrew. Andy. Then, suddenly, he was gone. I’d forgotten to count his fingers or note the color of his hair. What sort of mother forgets those things?</em></p>
<p class="body-text"><em class="italic">I fought to get him back, the way a drowning person fights for air.</em></p>
<p class="body-text"><em class="italic">A full year passed before I held him in my arms again. Finally, I could breathe, and I knew I would never, ever, let him go.</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Opening_Letter.vue?86033b16